<ng-container *ngIf="reminderDef">
  <form
    fxLayout="column"
    fxLayoutAlign="space-around"
    #reminderForm="ngForm"
    class="mdc-mb-2"
  >
    <h4 class="mt-1">{{ reminderDef.name }}</h4>
    <hr />
    <mat-tab-group (selectedTabChange)="selectedTabChange($event)">
      <mat-tab [label]="'EMAIL' | translate">
        <ng-container *ngIf="reminderDef.emailConfig">
          <div fxLayout="column">
            <mat-checkbox
              name="emailEnabled"
              [ngModel]="isChannelEnabled('email')"
              (ngModelChange)="setChannelEnabled('email', $event)"
              class="mdc-mb-1"
            >
              {{ "ENABLED" | translate }}
            </mat-checkbox>
            <ng-container
              [ngTemplateOutlet]="scheduleEditor"
              [ngTemplateOutletContext]="{ channel: 'email' }"
            >
            </ng-container>
            <hr />

            <mat-form-field appearance="outline" class="example-full-width">
              <mat-label>{{ "EMAIL_SUBJECT" | translate }}</mat-label>
              <input
                matInput
                [placeholder]="'EMAIL_SUBJECT' | translate"
                name="emailSubject"
                [(ngModel)]="reminderDef.emailConfig.subject"
              />
            </mat-form-field>
            <app-boarding-quick-links-editor
              *ngIf="reminderDef.type === 'PET_BOARDING'"
              #emailQuicklinksMessageEditor
              [selectedLinks]="reminderDef.emailConfig.links"
              [(editorContent)]="reminderDef.emailConfig.body"
              messageType="EMAIL"
            >
            </app-boarding-quick-links-editor>
            <app-appointment-quick-links-editor
              *ngIf="reminderDef.type === 'APPOINTMENT'"
              #emailQuicklinksMessageEditor
              [selectedLinks]="reminderDef.emailConfig.links"
              [(editorContent)]="reminderDef.emailConfig.body"
              messageType="EMAIL"
            >
            </app-appointment-quick-links-editor>
            <app-vaccination-quick-links-editor
              *ngIf="reminderDef.type === 'VACCINATION'"
              #emailQuicklinksMessageEditor
              [(editorContent)]="reminderDef.emailConfig.body"
              messageType="EMAIL"
            >
            </app-vaccination-quick-links-editor>
            <app-pet-quick-links-editor
              *ngIf="reminderDef.type === 'PET_BIRTHDAY'"
              #emailQuicklinksMessageEditor
              [(editorContent)]="reminderDef.emailConfig.body"
              messageType="EMAIL"
            >
            </app-pet-quick-links-editor>
            <app-deposit-quick-links-editor
              *ngIf="reminderDef.type === 'DEPOSIT'"
              #emailQuicklinksMessageEditor
              [(editorContent)]="reminderDef.emailConfig.body"
              messageType="EMAIL"
            >
            </app-deposit-quick-links-editor>
            <app-customer-quick-links-editor
              *ngIf="reminderDef.type === 'CUSTOMERS_LAST_INVOICE'"
              #emailQuicklinksMessageEditor
              [(editorContent)]="reminderDef.emailConfig.body"
              messageType="EMAIL"
            >
            </app-customer-quick-links-editor>
          </div>
        </ng-container>
      </mat-tab>

      <mat-tab [label]="'SMS' | translate">
        <ng-container *ngIf="reminderDef.smsConfig">
          <div fxLayout="column">
            <mat-checkbox
              name="smsEnabled"
              [ngModel]="isChannelEnabled('sms')"
              (ngModelChange)="setChannelEnabled('sms', $event)"
              class="mdc-mb-1"
            >
              {{ "ENABLED" | translate }}
            </mat-checkbox>
            <ng-container
              [ngTemplateOutlet]="scheduleEditor"
              [ngTemplateOutletContext]="{ channel: 'sms' }"
            >
            </ng-container>
            <hr />
            <h6>{{ "SMS_BODY" | translate }}</h6>
            <app-appointment-quick-links-editor
              #quickLinksEditorV2Component
              [selectedLinks]="reminderDef.smsConfig.links"
              *ngIf="
                reminderDef.type === 'APPOINTMENT' ||
                reminderDef.type === 'PET_BOARDING'
              "
              [(editorContent)]="reminderDef.smsConfig.text"
              messageType="SMS"
            >
            </app-appointment-quick-links-editor>
            <app-vaccination-quick-links-editor
              #quickLinksEditorV2Component
              *ngIf="reminderDef.type === 'VACCINATION'"
              [(editorContent)]="reminderDef.smsConfig.text"
              messageType="SMS"
            >
            </app-vaccination-quick-links-editor>
            <app-customer-quick-links-editor
              #quickLinksEditorV2Component
              *ngIf="reminderDef.type === 'CUSTOMERS_LAST_INVOICE'"
              [(editorContent)]="reminderDef.smsConfig.text"
              messageType="SMS"
            >
            </app-customer-quick-links-editor>
            <app-deposit-quick-links-editor
              #quickLinksEditorV2Component
              *ngIf="reminderDef.type === 'DEPOSIT'"
              [(editorContent)]="reminderDef.smsConfig.text"
              messageType="SMS"
            >
            </app-deposit-quick-links-editor>
            <app-pet-quick-links-editor
              #quickLinksEditorV2Component
              *ngIf="reminderDef.type === 'PET_BIRTHDAY'"
              [(editorContent)]="reminderDef.smsConfig.text"
              messageType="SMS"
            >
            </app-pet-quick-links-editor>
          </div>
        </ng-container>
      </mat-tab>
    </mat-tab-group>

    <ng-template #scheduleEditor let-channel="channel">
      <section class="mt-1 mdc-mb-2">
        <mat-card appearance="outlined" class="mx-0">
          <mat-card-content class="mdc-pb-0">
            <div fxLayout="row" fxLayoutAlign="space-between start" fxLayoutGap="16px">
              <div>
                <h6 class="mdc-mb-1">Choose when this {{ channel === 'email' ? 'email' : 'SMS' }} will be sent.</h6>
              </div>
              <button
                mat-button
                color="primary"
                (click)="addSchedule(channel)"
                [disabled]="!canAddSchedule(channel)"
                type="button"
              >
                <mat-icon class="mat-24">add</mat-icon>
                {{ "ADD_NEW" | translate }}
              </button>
            </div>

            <div fxLayout="column" fxLayoutGap="8px">
              <div
                *ngFor="
                  let schedule of getSchedules(channel);
                  trackBy: trackBySchedule;
                  index as i
                "
                fxLayout="row"
                fxLayout.xs="column"
                fxLayoutGap="10px"
                fxLayoutAlign="start center"
              >
                <mat-form-field appearance="outline" fxFlex="100" fxFlex.gt-xs="45">
                  <mat-label>When to send</mat-label>
                  <mat-select
                    [name]="channel + 'Schedule' + i"
                    [ngModel]="schedule"
                    [compareWith]="schedulesMatch"
                    (ngModelChange)="updateSchedule(channel, schedule, $event)"
                  >
                    <mat-option
                      *ngFor="
                        let option of scheduleOptionsFor(schedule);
                        trackBy: trackByScheduleOption
                      "
                      [value]="option.schedule"
                    >
                      {{ option.label }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <div *ngIf="schedule.scheduleType !== 'IMMEDIATE'" fxFlex="100" fxFlex.gt-xs="45">
                  <app-time-select
                    [placeholder]="'TIME_TO_SEND_REMINDER' | translate"
                    [date]="scheduleTimeAsDate(schedule)"
                    [interval]="15"
                    [required]="true"
                    (dateChange)="setScheduleTimeFromDate(channel, schedule, $event)"
                  >
                  </app-time-select>
                </div>

                <p *ngIf="schedule.scheduleType === 'IMMEDIATE'" fxFlex="100" fxFlex.gt-xs="45" class="mdc-mb-1">
                  This reminder will be sent immediately.
                </p>

                <button
                  type="button"
                  (click)="removeSchedule(channel, schedule)"
                  mat-icon-button
                  [attr.aria-label]="'Remove ' + formatSchedule(schedule)"
                  matTooltip="Remove schedule"
                >
                  <mat-icon role="img">delete</mat-icon>
                </button>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <mat-error *ngIf="isChannelMissingSchedule(channel)">
          {{ "AT_LEAST_ONE_SCHEDULE_REQUIRED" | translate }}
        </mat-error>
        <mat-error *ngIf="hasMissingScheduleTime(channel)">
          Choose a send time for every schedule except immediate reminders.
        </mat-error>
      </section>
    </ng-template>
  </form>
  <div>
    <button
      mat-raised-button
      color="accent"
      (click)="update()"
      [disabled]="!reminderForm.form.valid || !canSave()"
    >
      {{ "UPDATE" | translate }}
    </button>
  </div>
</ng-container>
